// Logo ridimensionato in locale (640×282): era un PNG remoto 2000×882 da 175 kB.
export default function Logo({ className = "h-8 w-auto", alt = "Maven Academy" }) {
  return (
    <picture>
      <source srcSet="/maven-academy-logo.webp" type="image/webp" />
      <img
        src="/maven-academy-logo.png"
        alt={alt}
        width="640"
        height="282"
        className={className}
        draggable="false"
        decoding="async"
      />
    </picture>
  );
}
